module.exports = __webpack_public_path__ + "6f3ce9ee2b6781d2f5ba6576d09a9eb2.svg";